/**
 * Javascript file for the legal disclosure page.
 * @author Adrian Rebmann, Yannik Sprengart
 */

export default {
  name: "Impressum",

  /**
   * The vue instance's data object.
   * @property {string} msg - The platform's name.
   */
  data() {
    return {
      msg: "WERNER"
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/datasecurity/impressum/impressum.js